export default function Btn({text, handleClick, id}) {
  return (
    <button 
        className='text-gradient btn-link cursor-pointer' 
        onClick={() => handleClick(id)}
    >
     {text}
    </button>
)
}
